<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="align-center">
        <v-img
          alt="v-feed Logo"
          class="shrink mr-2"
          contain
          src="./assets/vFeed_light.png"
          transition="scale-transition"
          width="40"
        />
      </div>
      <v-toolbar-title>v-Feed - Livestock Feed Management</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn
        href="https://vfeedmgr.com/"
        target="_blank"
        text
      >
        <span class="mr-2">Go To Console</span>
        <v-icon>mdi-login</v-icon>
      </v-btn>
    </v-app-bar>

    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>

<style>

</style>
